
import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 产品选择查询数据
 * @param {*} params
 */

export function query(data) {
  return request({
    url: BASE_API() + '/salePlan/findById',
    // url: 'http://192.168.222.155:8096/huigou/dictionary/querySysDictionaryDetailsByCode',
    // url: '/huigou/dictionary/slicedQuerySysDictionaries',
    // url: '/huigou/dictionary/querySysDictionaryDetailsByCode',
    method: 'get',
    // headers: {
    //  'Content-Type': 'application/x-www-form-urlencoded'
    // },    data: data
    params: {
      id: data
    }

  })
}



// WEBPACK FOOTER //
// ./src/api/platform/public/productSelect.js